import React, { useEffect, useRef, useState } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { deleteData, getAllDetails, getSpecificDetails, postAllData } from "../../service/ProductService";
import { ADD_SALES_TAX_DATA, ADD_SERVICE_DATA, DELETE_SERVICE, GET_INVOICE_ID, GET_INVOICE_PAYEE_LIST, GET_PAYEE_DETAIL_BY_ID, GET_SALES_TAX_LIST, GET_SERVICE_LIST, SAVE_INVOICE_DATA, GET_PROFILE_DATA_BY_ID } from "../../config/ApiConstant";
import { invoiceFormValidate, salesTaxValidate, ServiceNameValidate } from "../../config/Validate";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { convertDateFrom } from "../../appconfig/AppHelper";
import { InputNumber } from "primereact/inputnumber";
import { Skeleton } from "primereact/skeleton";
import Loader from "../../components/Loader/Loader";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";

const AddInvoice = () => {
  document.title = "Invoice | Nexawage";

  const navigate = useNavigate();
  const { payeeId } = useParams();

  const payee_id = payeeId ? atob(payeeId) : null;

  // taken is from state for user loged in
  const location: any = useLocation();
  const clientIdState = location?.state?.clientId;

  const [pageLoad, setPageLoad] = useState<boolean>(true);
  //Loading/Page Loading
  const [loading, setLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});
  const toast = useRef<any>(null);

  // set send mail loading
  const [sendMailLoading, setSendMailLoading] = useState<boolean>(false);

  // set add sales tax dialog
  const [addSalesTaxDialog, setAddSalesTaxDialog] = useState<boolean>(false);
  const [addServiceDialog, setAddServiceDialog] = useState<boolean>(false);
  const [submitSalesTaxLoading, setSubmitSalesTaxLoading] = useState<boolean>(false);
  const [submitServiceNameLoading, setSubmitServiceNameLoading] = useState<boolean>(false);
  const [salesTaxData, setSalesTaxData] = useState<any>({});
  const [serviceNameData, setServiceNameData] = useState<any>({});

  // disable btn
  const [disableBtn, setDisableBtn] = useState<boolean>(false);

  //   bill to information
  const [billToInformation, setBillToInformation] = useState<any>({});

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const userRole = userData?.roles?.role_name || "";
  let clientId: any = null;

  if (userRole === "User") {
    clientId = clientIdState;
  } else {
    clientId = userData?.id;
  }

  //Item Array - UPDATED to include gst_hst field
  const [serviceItemArray, setServiceItemArray] = useState<any[]>([
    {
      service: "",
      description: "",
      quantity: 1,
      rate: "",
      amount: 0.0,
      gst_hst: "",
      tax_id: "",
    },
  ]);

  //   Date Object
  const today = new Date();
  const [dates, setDates] = useState<String | Date | Date[] | null | any>(today);

  // adding 15 days from today date
  const [dueDate, setDueDate] = useState<String | Date | Date[] | null | any>();
  const [termsOfPayment, setTermsOfPayment] = useState<any>();

  //   calculation state
  const [hstTax, setHstTax] = useState<any>(0);

  //   sales tax state
  const [salesTaxOptions, setSalesTaxOptions] = useState<any>([]);
  const [showNewTaxInput, setShowNewTaxInput] = useState<boolean>(false);
  const [newTaxName, setNewTaxName] = useState<string>("");
  const [newTaxValue, setNewTaxValue] = useState<string>("");

  // service name state
  const [serviceNameOptions, setServiceNameOptions] = useState<any>([]);

  // invoice id
  const [invoiceId, setInvoiceId] = useState<any>();

  // selected payee
  const [selectedPayee, setSelectedPayee] = useState<any>();

  // payee Dropdown
  const [payeeDropdown, setPayeeDropdown] = useState<any>([]);

  // select mail send type on submit invoice form
  const [sendMailType, setSendMailType] = useState<any>(null);

  useEffect(() => {
    getInvoiceId();
    getPayeeNameAndDetail();
    onHandleChangePayee(payee_id);
    getSalesTaxData();
    getSalesTaxServiceName();
    getProfileData();
  }, []);

  const getProfileData = async () => {
    try {
      if (clientId) {
        const response = await getAllDetails(`${GET_PROFILE_DATA_BY_ID}/${clientId}`);
        if (response && response.date_format) {
          setBillToInformation((prev: any) => ({ ...prev, date_format: response.date_format }));
        }
      }
    } catch (error) { }
  };

  // useEffect to update dueDate based on dates
  useEffect(() => {
    if (dates) {
      const newDueDate = new Date(dates);
      const terms = parseInt(billToInformation?.terms_of_payment) || 0;
      newDueDate.setDate(newDueDate.getDate() + terms);
      setDueDate(newDueDate);
    }
  }, [dates, billToInformation?.terms_of_payment]);

  // Get Invoice id api call
  const getInvoiceId = async () => {
    try {
      const response = await getSpecificDetails(GET_INVOICE_ID, clientId);
      setInvoiceId(response);
      setPageLoad(false);
    } catch (error) { }
  };

  // get payee name and detail
  const getPayeeNameAndDetail = async () => {
    try {
      const response = await getAllDetails(`${GET_INVOICE_PAYEE_LIST}/${clientId}`);

      if (response) {
        const DataList = response;
        if (DataList.length === 0) {
          setPayeeDropdown([]);
        } else {
          const DataList = response.map((item: any) => ({
            name: `${item?.bill_to}`,
            value: item?.id,
          }));
          setPayeeDropdown(DataList);
        }
      }
    } catch (error) { }
  };

  const hideSalesTaxDialog = () => {
    setAddSalesTaxDialog(false);
    setSalesTaxData({});
    setErrors({});
  };
  const hideServiceDialog = () => {
    setAddServiceDialog(false);
    setServiceNameData({});
    setErrors({});
  };

  // add sales tax data
  const getSalesTaxData = async () => {
    try {
      const response = await getSpecificDetails(GET_SALES_TAX_LIST, clientId);
      const DataList = response.map((item: any) => ({
        name: `${item?.name} (${item?.value}%)`,
        value: item?.value,
        id: item?.id,
      }));
      DataList.push({ name: "Add More", value: "ADD_MORE", isFooter: true });
      setSalesTaxOptions(DataList);
    } catch (error: any) {
      toast.current.show({ severity: "error", summary: "Error", detail: error.response.data.message });
    }
  };

  const getSalesTaxServiceName = async () => {
    try {
      const response = await getSpecificDetails(GET_SERVICE_LIST, clientId);
      const DataList = [
        { name: "Add New Service", value: "ADD_MORE", isFooter: true },
        { name: "Other", value: "OTHER", isFooter: true },
        ...response.map((item: any) => ({
          name: `${item?.name}`,
          id: item?.id,
        })),
      ];
      setServiceNameOptions(DataList);
    } catch (error: any) {
      toast.current.show({ severity: "error", summary: "Error", detail: error.response.data.message });
    }
  };

  const submitSalesTaxData = async () => {
    try {
      const { errors, isError } = salesTaxValidate(salesTaxData);
      setErrors(errors);
      if (isError) return;
      setSubmitSalesTaxLoading(true);
      const payload = {
        name: salesTaxData?.name,
        value: salesTaxData?.value,
        client_id: clientId,
      };
      const response = await postAllData(ADD_SALES_TAX_DATA, payload);
      if (response) {
        getSalesTaxServiceName();
        toast.current.show({ severity: "success", summary: "Success", detail: response.message });
        setAddSalesTaxDialog(false);
        setSubmitSalesTaxLoading(false);
      }
    } catch (error: any) {
      setSubmitSalesTaxLoading(false);
      toast.current.show({ severity: "error", summary: "Error", detail: error.response.data.message });
    }
  }

  const submitServiceName = async () => {
    try {
      const { errors, isError } = ServiceNameValidate(serviceNameData);
      setErrors(errors);
      if (isError) return;
      setSubmitServiceNameLoading(true);
      const payload = {
        name: serviceNameData?.name,
        client_id: clientId,
      };

      const response = await postAllData(ADD_SERVICE_DATA, payload);
      if (response) {
        getSalesTaxServiceName();
        toast.current.show({ severity: "success", summary: "Success", detail: response.message });
        setAddServiceDialog(false);
        setSubmitServiceNameLoading(false);
        hideServiceDialog();
      }
    } catch (error: any) {
      setSubmitServiceNameLoading(false);
      toast.current.show({ severity: "error", summary: "Error", detail: error.response.data.message });
    }
  }

  const deleteServiceName = async (e: any, id: any) => {
    e.stopPropagation();
    try {
      const response = await deleteData(DELETE_SERVICE, id);
      if (response) {
        toast.current.show({ severity: "success", summary: "Success", detail: response.message });
        getSalesTaxServiceName();
      }
    } catch (error: any) {
      toast.current.show({ severity: "error", summary: "Error", detail: error.response.data.message });
    }
  };

  // on payee selected
  const onHandleChangePayee = async (e: any) => {
    // setSelectedPayee(e.value);
    setSelectedPayee(payee_id);

    const result = await getAllDetails(`${GET_PAYEE_DETAIL_BY_ID}/${payee_id}`);

    if (result) {
      // setPayeeDetails(result);
      setBillToInformation(result);
      setPageLoad(false);
    }
  };

  //onchange event
  const onInputChange = (e: any, name: string) => {
    let val;
    val = (e.target && e.target.value) || e.value || "";
    setBillToInformation({ ...billToInformation, [name]: val });
    setErrors({ ...errors, [name]: "" });
  };
  // on sales tax input change
  const onSalesTaxInputChange = (e: any, name: string) => {
    let val;
    val = (e.target && e.target.value) || e.value || "";
    setSalesTaxData({ ...salesTaxData, [name]: val });
    setErrors({ ...errors, [name]: "" });
  };


  const onServiceNameInputChange = (e: any, name: string) => {
    let val;
    val = (e.target && e.target.value) || e.value || "";
    setServiceNameData({ ...serviceNameData, [name]: val });
    setErrors({ ...errors, [name]: "" });
  };

  //   on radio button change
  const onInputChangeRadio = (e: any, name: any) => {
    setBillToInformation((prev: any) => ({
      ...prev,
      [name]: e.value,
    }));

    setErrors({ ...errors, [name]: "" });
  };

  //   onDate change
  const onDateChange = (e: any) => {
    setDates(e.value);
  };

  //   onDate change
  const onDueDateChange = (e: any) => {
    setDueDate(e.value);
  };

  const clearAll = (e: any) => {
    setBillToInformation({
      bill_to: [billToInformation?.bill_to],
      bill_email: [billToInformation?.bill_email],
      bill_address: [billToInformation?.bill_address],
      bill_phone: [billToInformation?.bill_phone],
    });
    setHstTax(0);
    setServiceItemArray([
      {
        service: "",
        description: "",
        quantity: 1,
        rate: "",
        amount: 0.0,
        gst_hst: "",
        tax_id: "",
      },
    ]);
    setErrors({});
  };

  // service Item Change
  const onServiceItemChange = (e: any, name: string, index: number) => {
    let tempSerciceItemArray = [...serviceItemArray];
    tempSerciceItemArray[index][name] = e.target.value || e.value;
    tempSerciceItemArray[index].amount =
      (parseFloat(tempSerciceItemArray[index].quantity) || 0) * (parseFloat(tempSerciceItemArray[index].rate) || 0);

    setServiceItemArray(tempSerciceItemArray);
    setErrors((prev: any) => ({ ...prev, [`${name}_${index}`]: "" }));
  };

  //   on description change
  const onDescriptionChange = (e: any, name: string, index: number) => {
    let tempSerciceItemArray = [...serviceItemArray];
    tempSerciceItemArray[index][name] = e.target.value || e.value;

    setServiceItemArray(tempSerciceItemArray);
  };

  // quantity/Rate change
  const onQuantityRateChange = (e: any, name: string, index: number) => {
    let tempItemArray = [...serviceItemArray];
    tempItemArray[index][name] = e?.target?.value ?? e?.value;
    tempItemArray[index].amount = (parseFloat(tempItemArray[index].quantity) || 0) * (parseFloat(tempItemArray[index].rate) || 0);

    setServiceItemArray(tempItemArray);
    setErrors((prev: any) => ({ ...prev, [`${name}_${index}`]: "" }));
  };

  // InputNumber's own paste parser can't strip a "$" in decimal mode, so handle pasted amounts (e.g. copied from a sheet) manually
  const onQuantityRatePaste = (e: any, name: string, index: number) => {
    const pasted = e.clipboardData?.getData("text") || "";
    const sanitized = parseFloat(pasted.replace(/[^0-9.-]/g, ""));
    if (!isNaN(sanitized)) {
      onQuantityRateChange({ value: sanitized }, name, index);
    }
  };

  // NEW: GST/HST change handler
  // NEW: GST/HST change handler
  const onGstHstChange = (e: any, index: number) => {
    if (e.value === "ADD_MORE") {
      setAddSalesTaxDialog(true);
      return;
    }

    let tempItemArray = [...serviceItemArray];
    tempItemArray[index].gst_hst = e.value || 0;

    // Find the selected option to get the ID
    const selectedOption = salesTaxOptions.find((option: any) => option.value === e.value);
    tempItemArray[index].tax_id = selectedOption ? selectedOption.id : "";

    setServiceItemArray(tempItemArray);
  };

  const onServiceNameChange = (e: any, index: number) => {
    if (e.value === "ADD_MORE" || e.value === "Add New Service") {
      setAddServiceDialog(true);
      return;
    }

    let tempItemArray = [...serviceItemArray];
    if (e.value === "Other") {
      tempItemArray[index].isOther = true;
      tempItemArray[index].service = "";
    } else {
      tempItemArray[index].service = e.value;
    }

    setServiceItemArray(tempItemArray);
  };

  //add Service item
  const addServiceItemTemplate = (rowData: any, { rowIndex }: any) => {
    return (
      <>
        <div className="input-effect-div">
          {rowData.isOther ? (
            <div className="w-full" style={{ position: "relative" }}>
              <InputTextarea
                value={rowData.service || ""}
                onChange={(e) => onServiceItemChange(e, "service", rowIndex)}
                placeholder="Enter Service Name"
                rows={1}
                autoResize
                className="w-full"
                style={{ paddingRight: "2.25rem" }}
              />
              <Button
                icon="pi pi-times"
                className="p-button-text p-button-rounded p-button-sm p-button-danger"
                style={{ position: "absolute", top: 0, right: 0 }}
                tooltip="Back to selection"
                tooltipOptions={{ position: 'bottom' }}
                onClick={() => {
                  let temp = [...serviceItemArray];
                  temp[rowIndex].isOther = false;
                  temp[rowIndex].service = "";
                  setServiceItemArray(temp);
                }}
              />
            </div>
          ) : (
            <div
              className="w-full"
              onDoubleClick={() => {
                // double click switches to free-text entry, keeping the current value
                let temp = [...serviceItemArray];
                temp[rowIndex].isOther = true;
                setServiceItemArray(temp);
              }}
            >
              <Dropdown
                value={rowData.service || ""}
                onChange={(e) => onServiceNameChange(e, rowIndex)}
                options={serviceNameOptions}
                optionLabel="name"
                optionValue="name"
                placeholder="Select Service"
                className="order-drp w-full"
                itemTemplate={itemServiceNameTemplate}
              />
            </div>
          )}
          <span className="focus-bg"></span>
        </div>
        <small className="p-invalid-txt">{errors[`service_${rowIndex}`]}</small>
      </>
    );
  };

  //add Description
  const addDescriptionTemplate = (rowData: any, { rowIndex }: any) => {
    return (
      <>
        <div className="input-effect-div">
          <InputTextarea
            value={rowData?.description || ""}
            name="description_"
            autoComplete="off"
            autoResize
            rows={2}
            onChange={(e) => onDescriptionChange(e, "description", rowIndex)}
            style={{ minWidth: "100px", flexWrap: "wrap", resize: 'vertical', overflow: 'auto' }}
            placeholder="Enter Description"
            className="w-full"
          />
        </div>
      </>
    );
  };

  //add Quantity
  const QtyTemplate = (rowData: any, { rowIndex }: any) => {
    return (
      <>
        <div className="input-effect-div">
          <InputNumber
            // keyfilter={"int"}
            value={rowData.quantity ? rowData.quantity : ""}
            name="quantity"
            onChange={(e) => onQuantityRateChange(e, "quantity", rowIndex)}
            onPaste={(e: any) => onQuantityRatePaste(e, "quantity", rowIndex)}
            className={errors[`quantity_${rowIndex}`] && "p-invalid"}
            style={{ minWidth: "100px" }}
            placeholder="Enter Quantity"
            maxFractionDigits={2}
            mode="decimal"
          />
          <span className="focus-bg"></span>
        </div>
        <small className="p-invalid-txt">{errors[`quantity_${rowIndex}`]}</small>
      </>
    );
  };

  //add rate
  const rateTemplate = (rowData: any, { rowIndex }: any) => {
    return (
      <>
        <div className="flex-1 input-effect-div p-inputgroup">
          <InputNumber
            value={!window.cn(rowData.rate) ? rowData.rate : ""}
            name="rate"
            onChange={(e) => onQuantityRateChange(e, "rate", rowIndex)}
            onPaste={(e: any) => onQuantityRatePaste(e, "rate", rowIndex)}
            className={errors[`rate_${rowIndex}`] && "p-invalid"}
            // minFractionDigits={2}
            maxFractionDigits={2}
            style={{ minWidth: "100px" }}
            mode="decimal"
            placeholder="0.00"
            useGrouping={false}
          />
          <span className="font-bold p-inputgroup-addon">$</span>
        </div>
        <small className="p-invalid-txt">{errors[`rate_${rowIndex}`]}</small>
      </>
    );
  };

  //add Amount
  const amountTemplate = (rowData: any, { rowIndex }: any) => {
    return (
      <InputText
        type="number"
        value={parseFloat(rowData.amount).toFixed(2)}
        name="amount"
        autoComplete="off"
        style={{ minWidth: "100px", textAlign: "right" }}
        disabled
      />
    );
  };

  const itemTemplate = (option: any) => {
    if (option.isFooter) {
      return (
        <Button
          icon="pi pi-plus"
          label="Add New Tax"
          onClick={() => setAddSalesTaxDialog(true)}
          className="p-button-text p-button-sm w-full"
        />
      );
    }
    return <div>{option.name}</div>;
  };
  const itemServiceNameTemplate = (option: any) => {
    if (option.isFooter) {
      if (option.value === "OTHER") {
        return (
          <div className="p-button p-button-text p-button-sm w-full text-left" style={{ justifyContent: 'flex-start', padding: '0.5rem 1rem', fontSize: '14px' }}>
            Other
          </div>
        );
      }
      return (
        <Button
          icon="pi pi-plus"
          label="Add New Service"
          onClick={() => setAddServiceDialog(true)}
          className="p-button-text p-button-sm w-full text-left"
          style={{ justifyContent: 'flex-start', fontSize: '14px' }}
        />
      );
    }
    return (
      <div className="flex align-items-center justify-content-between">
        <div>{option.name}</div>
        <Button
          icon="pi pi-trash"
          className="p-button-text p-button-rounded p-button-danger p-button-sm"
          onClick={(e) => deleteServiceName(e, option.id)}
        />
      </div>
    );
  };

  // GST/HST Template for DataTable Column
  const gstHstTemplate = (rowData: any, { rowIndex }: any) => {
    return (
      <>
        <div className="flex-1 input-effect-div p-inputgroup">
          <Dropdown
            value={rowData.gst_hst || 0}
            onChange={(e) => onGstHstChange(e, rowIndex)}
            options={salesTaxOptions}
            className={errors[`gst_hst_${rowIndex}`] && "p-invalid"}
            optionLabel="name"
            placeholder="Select Tax"
            itemTemplate={itemTemplate}
          />
          <span className="focus-bg"></span>

        </div>
        <small className="p-invalid-txt">{errors[`gst_hst_${rowIndex}`]}</small>
      </>
    );
  };



  //add multiple service data
  const handleItemArray = () => {
    // prefill sales tax from the last row
    const lastItem = serviceItemArray[serviceItemArray.length - 1];
    setServiceItemArray([
      ...serviceItemArray,
      {
        service: "",
        quantity: 1,
        rate: "",
        description: "",
        amount: 0.0,
        gst_hst: lastItem?.gst_hst ?? "",
        tax_id: lastItem?.tax_id ?? "",
      },
    ]);
  };

  // add new row pre filled with the last row's data, excluding the service name
  const handleCopyAsAbove = () => {
    const lastItem = serviceItemArray[serviceItemArray.length - 1];
    if (!lastItem) return;
    setServiceItemArray([...serviceItemArray, { ...lastItem, service: "", isOther: false }]);
  };

  // only allow copying the last row once it actually has data filled in
  const lastRowHasData = () => {
    const lastItem = serviceItemArray[serviceItemArray.length - 1];
    if (!lastItem) return false;
    return Boolean(lastItem.service?.trim() || lastItem.rate || lastItem.description?.trim() || lastItem.gst_hst);
  };

  // remove service row
  const removeRowTemplate = (_: any, { rowIndex }: any) => {
    if (serviceItemArray.length === 1) {
      return " - ";
    } else {
      return (
        <>
          <Button icon="pi pi-trash" className="p-button-danger p-button-rounded " onClick={() => handleRemoveRow(rowIndex)} />
        </>
      );
    }
  };

  //   remove service row index
  const handleRemoveRow = (index: number) => {
    let updatedRows = [...serviceItemArray];

    updatedRows.splice(index, 1);

    setServiceItemArray(updatedRows);
  };

  // total quantity across all service rows
  const getTotalQuantity = () => {
    return serviceItemArray.reduce((sum: number, item: any) => sum + (parseFloat(item.quantity) || 0), 0);
  };

  //getSun total - UPDATED to calculate per-row GST/HST
  const getTotal = () => {
    let subTotal: any = 0;
    let totalTaxAmount: any = 0;
    let totalAmount: any = 0;
    let totalGst: any = 0;
    let totalHst: any = 0;
    let rowTaxBreakdown: any[] = [];

    serviceItemArray.forEach((item: any, index: number) => {
      let quantity = parseFloat(item.quantity) || 0;
      let rate = parseFloat(item.rate) || 0;
      let gstHstPercent = parseFloat(item.gst_hst) || 0;

      let itemSubTotal = quantity * rate;
      let itemTax = (gstHstPercent * itemSubTotal) / 100;

      // Accumulate totals
      subTotal += itemSubTotal;
      totalGst += itemTax;

      // Store breakdown for display
      {
        gstHstPercent > 0 && (
          rowTaxBreakdown.push({
            service: item.service,
            amount: itemSubTotal,
            gstPercent: gstHstPercent,
            gstAmount: itemTax,
          })
        )
      }
    });

    // hst on subtotal (if you still want a global HST)
    totalHst = (hstTax * subTotal) / 100;

    // total tax (gst + hst )
    totalTaxAmount = totalGst + totalHst;

    totalAmount = subTotal + totalTaxAmount;

    return {
      subTotal: subTotal.toFixed(2),
      totalGst: totalGst,
      totalHst: totalHst,
      totalTaxAmount: totalTaxAmount.toFixed(2),
      totalAmount: totalAmount.toFixed(2),
      rowTaxBreakdown: rowTaxBreakdown,
    };
  };

  //on submit api call - UPDATED payload to include per-row GST/HST
  const onInvoiceFormSubmit = async (type: any = null) => {
    try {
      const { errors, isError } = invoiceFormValidate(billToInformation, serviceItemArray, dates, dueDate);
      setErrors(errors);

      //Check Error if no errors then call API
      if (!isError) {
        if (type === "sendMail") {
          setSendMailLoading(true);
        } else {
          setLoading(true);
        }
        setDisableBtn(true);

        //Request object
        const payload = {
          invoice_no: invoiceId,
          purchase_order_no: billToInformation?.purchase_order_no,
          invoice_recipient_id: selectedPayee,
          client_id: clientId,
          bill_to: billToInformation?.bill_to,
          bill_address: billToInformation?.bill_address,
          bill_phone: billToInformation?.bill_phone,
          bill_email: billToInformation?.bill_email,
          notes: billToInformation?.notes,

          date: convertDateFrom(dates),
          terms_of_payment: billToInformation?.terms_of_payment,
          due_date: convertDateFrom(dueDate),

          sub_total: getTotal().subTotal,
          hst: !window.cn(hstTax) ? hstTax : 0,
          hst_tax: getTotal().totalHst,
          total: getTotal().totalAmount,
          ...(type === "sendMail" && { send_mail: "1" }),

          line_items: serviceItemArray,
        };


        //apicall
        const response = await postAllData(SAVE_INVOICE_DATA, payload);

        if (response) {
          toast.current?.show({
            severity: "success",
            summary: "Success",
            detail: response.message,
          });
          if (type === "sendMail") {
            setSendMailLoading(false);
            setDisableBtn(false);
          } else {
            setLoading(false);
            setDisableBtn(false);
          }
          setTimeout(() => {
            window.open(response?.data, "_blank");
            navigate("/invoice-list", { state: { clientId: clientId } });
          }, 1500);
        }
      }
    } catch (error: any) {
      if (type === "sendMail") {
        setSendMailLoading(false);
        setDisableBtn(false);
      } else {
        setLoading(false);
        setDisableBtn(false);
      }
      toast.current?.show({
        severity: "error",
        summary: "Alert",
        detail: error?.response?.data?.message,
      });
    }
  };

  // table description column header
  const descriptionHeaderTemplate = () => {
    return (
      <div style={{ lineHeight: "1.5", letterSpacing: "0.5px", fontSize: "13px" }} className="text-center">
        <div style={{ fontWeight: "600", letterSpacing: "0.7px" }}>Description</div>
        <small style={{ color: "#6c757d" }}>(For multiple items please enter comma separated)</small>
      </div>
    );
  };

  return (
    <>
      <AppBreadcrumb currentMenu="Invoice" pageName="Form" pageTitle="Invoice" goToPage={true} />

      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white crud-demo lg:p-2 relative">
            <Toast ref={toast} />

            {!pageLoad ? (
              <>
                <div className="p-fluid formgrid grid">
                  <div className="field col-12">
                    <h4 className="mb-0">Bill To Information</h4>
                  </div>

                  {/* Bill To */}
                  <div className="field col-12 md:col-4">
                    <label htmlFor="bill_to">Bill To *</label>
                    <div className="input-effect-div">
                      <InputText
                        value={billToInformation?.bill_to || ""}
                        autoComplete="off"
                        id="bill_to"
                        disabled={true}
                        placeholder="Enter Bill To"
                        onChange={(e) => onInputChange(e, "bill_to")}
                        className={errors["bill_to"] && "p-invalid"}
                      />
                      <small className="p-invalid-txt">{errors["bill_to"]}</small>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="field col-12 md:col-4">
                    <label htmlFor="email">Email </label>
                    <div className="input-effect-div">
                      <InputText
                        value={billToInformation?.bill_email || ""}
                        autoComplete="off"
                        id="bill_email"
                        disabled={true}
                        placeholder="Enter Email"
                        onChange={(e) => onInputChange(e, "bill_email")}
                        className={errors["bill_email"] && "p-invalid"}
                      />
                      <small className="p-invalid-txt">{errors["bill_email"]}</small>
                    </div>
                  </div>

                  {/* Phone Number */}
                  <div className="field col-12 md:col-4">
                    <label htmlFor="bill_phone">Phone Number </label>
                    <div className="flex-1 input-effect-div p-inputgroup">
                      <span className="font-bold p-inputgroup-addon">+1</span>
                      <InputText
                        value={billToInformation.bill_phone || ""}
                        name="bill_phone"
                        autoComplete="off"
                        disabled={true}
                        placeholder="Enter Phone Number"
                        onChange={(e) => onInputChange(e, "bill_phone")}
                        className={errors["bill_phone"] && "p-invalid"}
                        keyfilter="pint"
                        maxLength={10}
                      />
                      <span className="focus-bg"></span>
                    </div>
                    <small className="p-invalid-txt">{errors["bill_phone"]}</small>
                  </div>

                  {/* Address */}
                  <div className="field col-12 md:col-4">
                    <label htmlFor="bill_address">Address </label>
                    <div className="input-effect-div">
                      <InputTextarea
                        value={billToInformation?.bill_address || ""}
                        autoComplete="off"
                        rows={2}
                        id="bill_address"
                        disabled={true}
                        placeholder="Enter Address"
                        onChange={(e) => onInputChange(e, "bill_address")}
                        className={errors["bill_address"] && "p-invalid"}
                      />
                      <small className="p-invalid-txt">{errors["bill_address"]}</small>
                    </div>
                  </div>

                  <div className="field col-12 mt-3">
                    <h4 className="mb-0">Invoice Information</h4>
                  </div>

                  {/* Invoice Number*/}
                  <div className="field col-12 md:col-4">
                    <label htmlFor="client_id">Invoice Number </label>
                    <div className="input-effect-div">
                      <InputText
                        keyfilter="num"
                        value={invoiceId || ""}
                        autoComplete="off"
                        id="client_id"
                        onChange={(e) => setInvoiceId(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Purchase Order Number */}
                  <div className="field col-12 md:col-4">
                    <label htmlFor="purchase_order_no">Purchase Order Number</label>
                    <div className="input-effect-div">
                      <InputText
                        value={billToInformation?.purchase_order_no || ""}
                        autoComplete="off"
                        id="purchase_order_no"
                        placeholder="Enter Purchase Order Number"
                        onChange={(e) => onInputChange(e, "purchase_order_no")}
                      />
                    </div>
                  </div>

                  {/* Date */}
                  <div className="field col-12 md:col-4">
                    <label htmlFor="date">Date</label>
                    <Calendar
                      value={dates}
                      dateFormat={(billToInformation?.date_format || "dd/mm/yy").replace("yyyy", "yy")}
                      onChange={(e) => onDateChange(e)}
                      showIcon
                      className={errors["date"] && "p-invalid"}
                    />
                    <small className="p-invalid-txt">{errors["date"]}</small>
                  </div>

                  {/* Terms of Payment */}
                  <div className="field col-12 md:col-4">
                    <label htmlFor="terms_of_payment">Terms of Payment (in days) *</label>
                    <div className="input-effect-div">
                      <InputNumber
                        value={billToInformation?.terms_of_payment}
                        onValueChange={(e) => onInputChange(e, "terms_of_payment")}
                        placeholder="Enter number of days"
                        min={0}
                        useGrouping={false}
                        id="terms_of_payment"
                        className={errors["terms_of_payment"] && "p-invalid"}
                      />
                    </div>
                    <small className="p-invalid-txt">{errors["terms_of_payment"]}</small>
                  </div>

                  {/* Due Date */}
                  <div className="field col-12 md:col-4">
                    <label htmlFor="reference">Due Date *</label>
                    <Calendar
                      value={dueDate}
                      disabled
                      dateFormat={(billToInformation?.date_format || "dd/mm/yy").replace("yyyy", "yy")}
                      onChange={(e) => onDueDateChange(e)}
                      showIcon
                      placeholder="Enter Due Date"
                      className={errors["due_date"] && "p-invalid"}
                    />
                    <small className="p-invalid-txt">{errors["due_date"]}</small>
                  </div>

                  <div className="field col-12 mt-4">
                    <h4 className="mb-0">Service Details</h4>
                  </div>

                  {/* service table - UPDATED with GST/HST column */}
                  <div className="field col-12 md:col-12">
                    <DataTable
                      value={serviceItemArray}
                      reorderableRows
                      onRowReorder={(e) => setServiceItemArray(e.value)}
                      reorderableColumns
                      responsiveLayout="scroll"
                      showGridlines
                      footerColumnGroup={
                        serviceItemArray.length > 1 ? (
                          <ColumnGroup>
                            <Row>
                              <Column colSpan={3} />
                              <Column footer={`Total Quantity: ${getTotalQuantity()}`} footerStyle={{ textAlign: "center" }} />
                              <Column colSpan={4} />
                            </Row>
                          </ColumnGroup>
                        ) : undefined
                      }
                    >
                      <Column rowReorder style={{ width: "3%" }} />
                      <Column field="service" header="Service Name" body={addServiceItemTemplate} style={{ width: "16%" }} />
                      <Column field="description" header={descriptionHeaderTemplate} body={addDescriptionTemplate} style={{ width: "20%" }} />
                      <Column field="quantity" header="Quantity" body={QtyTemplate} style={{ width: "14%" }} />
                      <Column field="rate" header="Rate" body={rateTemplate} style={{ width: "14%" }} />
                      <Column field="amount" header="Amount" body={amountTemplate} style={{ width: "14%" }} />
                      <Column field="gst_hst" header="Sales tax" body={gstHstTemplate} style={{ width: "14%" }} />
                      <Column header="Action" body={removeRowTemplate} style={{ width: "8%" }} />
                    </DataTable>
                  </div>

                  <div className="field col-12 md:col-12 grid justify-content-between mb-0">
                    <div className="field col-12 md:col-5 flex flex-column justify-content-between">
                      <div className="flex gap-2">
                        <Button icon="pi pi-plus" label="Add New Row" className="p-button" onClick={handleItemArray} style={{ width: "auto" }} />
                        {lastRowHasData() && (
                          <Button icon="pi pi-copy" label="Copy as Above" className="p-button" onClick={handleCopyAsAbove} style={{ width: "auto" }} />
                        )}
                      </div>

                      {/* Reference Note */}
                      <div className="mt-5">
                        <label htmlFor="reference ">Note</label>
                        <div className="input-effect-div mt-2">
                          <InputTextarea
                            value={!window.cn(billToInformation.notes) ? billToInformation.notes : ""}
                            autoComplete="off"
                            id="notes"
                            onChange={(e) => onInputChange(e, "notes")}
                            className={errors["notes"] && "p-invalid"}
                            rows={3}
                          />
                          <span className="focus-bg"></span>
                        </div>
                      </div>
                    </div>

                    {/* sub Total - UPDATED with per-row GST/HST breakdown */}
                    <div className="field col-12 md:col-6 total-card p-4 ">
                      <div className="flex justify-content-between mb-3 ">
                        <h6 className="mt-0 mb-0">Sub Total</h6>
                        <h6 className="mt-0 mb-0">{`$${getTotal().subTotal}`}</h6>
                      </div>

                      {/* Display per-row GST/HST breakdown */}
                      {getTotal().rowTaxBreakdown.map((row: any, idx: number) => {
                        const serviceText = row.service && row.service.length > 10 ? row.service.slice(0, 10) + "..." : row.service;

                        return (

                          <div key={idx} className="flex justify-content-between mb-2 align-items-center">
                            <label style={{ color: "#6c757d" }}>
                              GST/HST @ {row.gstPercent}% on ${row.amount.toFixed(2)} {serviceText && `(${serviceText})`}
                            </label>
                            <h6 className="mt-0 mb-0">{`$${row.gstAmount.toFixed(2)}`}</h6>
                          </div>
                        );
                      })}
                      <hr />

                      <div className="flex justify-content-between mb-5 align-items-center">
                        <label htmlFor="tax-amount" className="block font-bold mr-5">
                          Total Tax
                        </label>
                        <h6 className="mt-0 mb-0">{`$${getTotal().totalTaxAmount}`}</h6>
                      </div>

                      <hr />

                      <div className="flex justify-content-between mb-5 align-items-center">
                        <h5 className="block font-bold">Total</h5>
                        <h5 className="mt-0 mb-0">{`$${getTotal().totalAmount}`}</h5>
                      </div>
                    </div>
                    <div style={{ color: "red" }} className="p-2">
                      <span className="text-lg">
                        <b className="font-bold" style={{ color: "red" }}>
                          Note :
                        </b>
                        {` On submit email will be sent to`} <span>{` ${billToInformation?.bill_email}`}</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="card-footer flex flex-wrap gap-2 mt-4 md:gap-3 justify-content-end align-items-center">
                  <div className="button-group">
                    <Button
                      label="Cancel"
                      icon="pi pi-times"
                      className="p-button-secondary mr-4"
                      disabled={loading || disableBtn}
                      onClick={clearAll}
                    />
                    <Button label="Submit" icon="pi pi-check" loading={loading} disabled={disableBtn} onClick={onInvoiceFormSubmit} />
                    <div className="mt-3 flex justify-content-center">
                      <Button
                        label="Submit & Send Email"
                        icon="pi pi-check"
                        loading={sendMailLoading}
                        disabled={loading || disableBtn}
                        onClick={() => onInvoiceFormSubmit("sendMail")}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <Skeleton height="500px" className="mt-3 mb-3 border-round" />
            )}

            {pageLoad === true && <Loader />}
          </Card>
        </div>
      </div>
      {/* Add sales tax Dialog */}
      <Dialog
        visible={addSalesTaxDialog}
        header="Add Sales Tax"
        draggable={false}
        style={{ width: "400px" }}
        className="mx-3"
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideSalesTaxDialog} />
            <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={submitSalesTaxData} loading={submitSalesTaxLoading} />
          </div>
        }
        onHide={hideSalesTaxDialog}
      >
        <div className="grid p-fluid formgrid">
          <div className="field col-12">
            <label htmlFor="name">Tax Name *</label>
            <InputText
              id="name"
              value={salesTaxData?.name || ""}
              name="name"
              autoComplete="off"
              placeholder="Enter Tax Name"
              onChange={(e) => onSalesTaxInputChange(e, "name")}
              className={errors["name"] && "p-invalid"}
            />
            <small className="p-invalid-txt">{errors["name"]}</small>
          </div>
          <div className="field col-12">
            <label htmlFor="vaccation_payout">Tax Percentage*</label>
            <form autoComplete="off">
              <div className="flex-1 input-effect-div p-inputgroup">
                <InputNumber
                  value={salesTaxData?.value || ""}
                  name="value"
                  onChange={(e) => onSalesTaxInputChange(e, "value")}
                  placeholder="Enter Tax Percentage"
                  className={errors["value"] && "p-invalid"}
                  maxFractionDigits={2}
                  mode="decimal"
                  useGrouping={false}
                />
                <span className="font-bold p-inputgroup-addon">%</span>
                {/* <span className="focus-bg"></span> */}
              </div>
            </form>
            <small className="p-invalid-txt">{errors["value"]}</small>
          </div>
        </div>
      </Dialog>
      {/* Add service Dialog */}
      <Dialog
        visible={addServiceDialog}
        header="Add Service Name"
        draggable={false}
        style={{ width: "400px" }}
        className="mx-3"
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideServiceDialog} />
            <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={submitServiceName} loading={submitServiceNameLoading} />
          </div>
        }
        onHide={hideServiceDialog}
      >
        <div className="grid p-fluid formgrid">
          <div className="field col-12">
            <label htmlFor="name">Service Name *</label>
            <InputText
              id="name"
              value={serviceNameData?.name || ""}
              name="name"
              autoComplete="off"
              placeholder="Enter Service Name"
              onChange={(e) => onServiceNameInputChange(e, "name")}
              className={errors["name"] && "p-invalid"}
            />
            <small className="p-invalid-txt">{errors["name"]}</small>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default AddInvoice;
